import React from 'react';

import baibolLogo from '../../assets/img/logo.svg';
import whiteLogo from '../../assets/img/white-logo.svg';

interface IBaibolLogo {
    width?: number;
    height?: number;
    isWhite?: boolean;
}

const BaibolLogo: React.FC<IBaibolLogo> = ({ isWhite, width, height }) => (
    <a href="/">
        {isWhite ?
            <img src={whiteLogo} alt="Микрокредитная компания «Байбол»" /> :
            <img src={baibolLogo} alt="Микрокредитная компания «Байбол»" width={width} height={height} />
        }
    </a>
);

export default BaibolLogo;
